import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Linkedin, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-collaborb-inner text-slate-300 py-14">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid gap-10 lg:grid-cols-[1.3fr_repeat(3,1fr)]">
          <div>
            <div className="section-kicker mb-4 !bg-white/10 !text-sky-200">CollabOrb</div>
            <h3 className="text-2xl font-bold text-white mb-3">Built for clear, measurable creator partnerships.</h3>
            <p className="text-sm leading-7 text-slate-400 max-w-md">
              A modern marketplace for brands and creators to discover each other, launch campaigns, and manage collaborations with more confidence.
            </p>
            <div className="mt-6 flex flex-wrap gap-3 text-sm">
              <a href="mailto:support@collaborb.com" className="secondary-button !bg-white/5 !text-white !border-white/10 hover:!border-sky-300/40">
                <Mail className="h-4 w-4" />
                support@collaborb.com
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">Product</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><Link to="/" className="hover:text-white">Home</Link></li>
              <li><Link to="/signup" className="hover:text-white">Get started</Link></li>
              <li><Link to="/about" className="hover:text-white">How CollabOrb works</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">Company</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><Link to="/about" className="hover:text-white">About</Link></li>
              <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
              <li><a href="/privacy-policy.html" className="hover:text-white">Privacy policy</a></li>
              <li><a href="/terms-of-service.html" className="hover:text-white">Terms of service</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-white">Connect</h4>
            <div className="space-y-3 text-sm text-slate-400">
              <a href="https://www.instagram.com/collaborb/" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white">
                <Instagram className="h-4 w-4" />
                Instagram
              </a>
              <a href="https://www.linkedin.com" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white">
                <Linkedin className="h-4 w-4" />
                LinkedIn
              </a>
              <p className="text-slate-500">Response window: typically within 1-2 business days.</p>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-white/10 pt-6 text-sm text-slate-500 md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} CollabOrb. All rights reserved.</p>
          <p>Modern creator marketing with clearer workflows for brands and creators.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
